<template>
  <div class="basicPortContent">
    <Breadcrumb :matched="$route.matched" />
    <BaseQuery class="callback-test" :loading="loading">
      <el-form
        slot="searchBox"
        size="mini"
        label-position="right"
        label-width="100px"
        inline
        class="callback-form"
      >
        <el-form-item label="监听">
          <el-autocomplete
            v-model="options.listenTo"
            placeholder="listen..."
            clearable
            :disabled="options.listening"
            :fetch-suggestions="querySearch"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="doListen">
            {{ options.listening ? '取消' : '监听' }}
          </el-button>

          <el-button @click="elements = []">清空</el-button>

          <el-button v-show="options.listening" @click="sendMessage('list')">
            当前在线监听器
          </el-button>
        </el-form-item>

        <el-form-item style="flex-grow: 1; text-align: right">
          <div class="listen-stat">
            <span v-for="stat in printStats" :key="stat.k">
              {{ stat.k }}: {{ stat.v }}
            </span>
          </div>
          <div v-show="options.listening" class="listen-topic">
            <i class="el-icon-loading"></i>
            Listening
            <span v-if="options.listenTo">{{ options.listenTo }}</span> ...
          </div>
        </el-form-item>
      </el-form>

      <div ref="output" class="callback-container">
        <div class="callback-wrapper">
          <component
            :is="parseComponent(ele.type)"
            v-for="ele in elements"
            :key="ele.id"
            :data-index="ele.id"
            :ele="ele"
            class="callback-item"
            :class="`callback-type-` + ele.type"
          />
        </div>
      </div>
    </BaseQuery>
  </div>
</template>

<script>
import BaseQuery from '@/components/BaseQuery.vue'
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import { loadHighlight } from '@/mixins/highlight.js'

const wsUri =
  (location.protocol === 'https:' ? 'wss' : 'ws') +
  '://monitor.test.freightower.com/traceOpsSocket/websocket'

const isJson = msg => {
  if (!msg) {
    return
  }

  let i = 0,
    l = msg.length,
    j = l - 1,
    c0,
    c1

  while (i <= j) {
    c0 = msg.charAt(i)

    if (c0 === ' ' || c0 === '\n') {
      i++
    } else {
      break
    }
  }

  while (i <= j) {
    c1 = msg.charAt(j)

    if (c1 === ' ' || c1 === '\n') {
      j--
    } else {
      break
    }
  }

  return (
    i <= j &&
    (c0 === '[' || c0 === '{') &&
    c0.charCodeAt(0) + 2 === c1.charCodeAt(0)
  )
}

const Elem = {
  props: {
    ele: {
      type: Object,
    },
  },
}

// basic element.

const JsonEle = async () => {
  // load high.
  await loadHighlight()

  return Object.assign(
    {
      computed: {
        jsonValue() {
          return hljs.highlight(this.ele.value, { language: 'json' }).value
        },
      },

      render(h) {
        return h('pre', {}, [
          h('code', { domProps: { innerHTML: this.jsonValue } }),
        ])
      },
    },
    Elem
  )
}

const TextEle = Object.assign(
  {
    render(h) {
      return h('div', {}, this.ele.value)
    },
  },
  Elem
)

const basicComponents = {
  components: {
    JsonEle,
    TextEle,
  },
}

const ListEle = Object.assign(
  {
    render(h) {
      return h('div', {}, [
        h('el-table', { props: { data: this.ele.value } }, [
          h('el-table-column', { props: { prop: 'session', label: 'ID' } }),
          h('el-table-column', { props: { prop: 'k', label: 'Key' } }),
          h('el-table-column', {
            props: { prop: 'connectionTime', label: 'Connection Time' },
          }),
        ]),
      ])
    },
  },
  Elem
)

const parseComponent = type => {
  if (type === 'json') {
    return 'JsonEle'
  }

  if (type === 'callback') {
    return 'CallbackEle'
  }

  if (type === 'list') {
    return 'ListEle'
  }

  return 'TextEle'
}

export default {
  name: 'CallbackTest',
  components: {
    BaseQuery,
    Breadcrumb,

    JsonEle: JsonEle,

    TextEle: TextEle,

    ListEle: ListEle,

    CallbackEle: Object.assign(
      {
        mixins: [basicComponents],

        methods: {
          innerComponent(h) {
            const { body } = this.ele.value

            if (isJson(body)) {
              const bodyJson = JSON.parse(body)

              if (typeof bodyJson.subscription === 'object') {
                // subscription.
                // Table Ele

                const subscription = bodyJson.subscription

                return h('div', { staticStyle: { marginTop: '5px' } }, [
                  h('el-row', { props: { gutter: 10 } }, [
                    h(
                      'el-col',
                      { props: { span: 6 } },
                      `单号: ${subscription.bill}`
                    ),
                    h(
                      'el-col',
                      { props: { span: 6 } },
                      `箱号: ${subscription.ctnr}`
                    ),
                    h(
                      'el-col',
                      { props: { span: 6 } },
                      `船公司: ${subscription.carrier}`
                    ),
                    h(
                      'el-col',
                      { props: { span: 6 } },
                      `账号: ${subscription.uname}`
                    ),
                  ]),

                  h(
                    'el-row',
                    {
                      props: { gutter: 10 },
                      staticStyle: { marginTop: '10px' },
                    },
                    [
                      h(
                        'el-col',
                        { props: { span: 6 } },
                        `mmsi: ${subscription.mmsi}`
                      ),
                      h(
                        'el-col',
                        { props: { span: 6 } },
                        `船名: ${subscription.vessel}`
                      ),
                      h(
                        'el-col',
                        { props: { span: 6 } },
                        `港口名: ${subscription.nameEn}`
                      ),
                      h(
                        'el-col',
                        { props: { span: 6 } },
                        `港口代码: ${subscription.code}`
                      ),
                    ]
                  ),

                  h(
                    'el-row',
                    {
                      props: { gutter: 10 },
                      staticStyle: { marginTop: '10px' },
                    },
                    [
                      h(
                        'el-col',
                        { props: { span: 6 } },
                        `开始时间: ${subscription.btm}`
                      ),
                      h(
                        'el-col',
                        { props: { span: 6 } },
                        `结束时间: ${subscription.etm}`
                      ),
                      h(
                        'el-col',
                        { props: { span: 12 } },
                        `查询时间范围: ${bodyJson.begin} - ${bodyJson.end}`
                      ),
                    ]
                  ),

                  h(
                    'el-table',
                    {
                      props: { data: bodyJson.voyages || [], size: 'mini' },
                      staticStyle: { marginTop: '10px' },
                    },
                    [
                      h('el-table-column', {
                        props: { prop: 'ata', label: 'Ata' },
                      }),
                      h('el-table-column', {
                        props: { prop: 'atd', label: 'Atd' },
                      }),
                      h('el-table-column', {
                        props: { prop: 'portCode', label: 'PortCode' },
                      }),
                      h('el-table-column', {
                        props: { prop: 'portEnName', label: 'PortEnName' },
                      }),
                      h('el-table-column', {
                        props: { prop: 'portTimeZone', label: 'PortTimeZone' },
                      }),
                      h('el-table-column', {
                        props: { prop: 'countryCode', label: 'CountryCode' },
                      }),
                    ]
                  ),
                ])
              } else {
                return h('JsonEle', {
                  props: { ele: { value: JSON.stringify(bodyJson, null, 2) } },
                })
              }
            } else {
              return h('TextEle', { props: { ele: { value: body || '' } } })
            }
          },
        },

        render(h) {
          return h('div', {}, [
            h(
              'div',
              {},
              `--------- ${this.ele.value.k}(${this.ele.value.receiveTime}) ---------`
            ),
            this.innerComponent(h),
          ])
        },
      },
      Elem
    ),
  },

  data() {
    return {
      loading: false,

      options: {
        listenTo: '',
        listening: false,
      },

      elements: [],

      parseComponent: parseComponent,

      stats: {},
    }
  },

  computed: {
    printStats() {
      let ret = []

      // console.log(Object.entries(this.stats).sort((a, b) => b[1] - a[1]));
      for (let item of Object.entries(this.stats).sort((a, b) => b[1] - a[1])) {
        ret.push({ k: item[0], v: item[1] })
        if (ret.length >= 10) {
          break
        }
      }
      return ret
    },
  },

  destroyed() {
    this.stopListen()
  },

  mounted() {
    let timer

    this.$on('open', () => {
      clearInterval(timer)
      timer = setInterval(() => this.ws && this.ws.send('heartbeat'), 6000)
    })

    this.$on(['close', 'error'], ev => {
      clearInterval(timer)
      this.options.listening = false
      this.appendElement('Connection interrupted.', 'text')
    })

    this.$on('receive', msg => {
      if (isJson(msg)) {
        const msgJson = JSON.parse(msg)

        // callback msg;
        if (msgJson.uri && msgJson.k && msgJson.receiveTime) {
          delete msgJson.uri
          delete msgJson.headers

          // this.stats[msgJson.k] = (this.stats[msgJson.k] || 0) + 1;

          this.$set(this.stats, msgJson.k, (this.stats[msgJson.k] || 0) + 1)

          this.appendElement(msgJson, 'callback')
        }
        // list
        else if (
          Array.isArray(msgJson) &&
          msgJson[0] &&
          msgJson[0].connectionTime
        ) {
          this.appendElement(msgJson, 'list')
        } else {
          this.appendElement(JSON.stringify(msgJson, null, 2), 'json')
        }
      } else {
        this.appendElement(msg, 'text')
      }
    })

    this.$on('listenTo', topic => {
      const value = localStorage.getItem('callback:test')

      const items = isJson(value) ? JSON.parse(value) : []

      if (!items.includes(topic)) {
        if (items.length > 10) {
          items.shift()
        }
        items.push(topic)
        localStorage.setItem('callback:test', JSON.stringify(items))
      }
    })

    this.querySearch(
      null,
      items => (this.options.listenTo = (items[0] || '').value || '')
    )
  },

  methods: {
    async doListen() {
      if (this.options.listening) {
        // close ws.
        this.stopListen()
        this.options.listening = false
      } else {
        this.options.listening = true

        if (this.options.listenTo) {
          this.$emit('listenTo', this.options.listenTo)
        }

        try {
          this.startListen(this.options.listenTo)
        } catch (e) {
          this.options.listening = false
        }
      }
    },

    startListen(topic) {
      this.stats = {}

      this.ws = new WebSocket(wsUri + (topic ? `?k=${topic}` : ''))

      this.ws.onmessage = ev => this.$emit('receive', ev.data)

      this.ws.onclose = ev => this.$emit('close', ev)

      this.ws.onerror = ev => this.$emit('error', ev)

      this.ws.onopen = ev => this.$emit('open', ev)
    },

    stopListen() {
      if (this.ws) {
        this.ws.close()
        this.ws = undefined
      }
    },

    appendElement(msg, type) {
      const l = this.elements.length

      let ele

      if (l < 100) {
        ele = {
          value: msg,
          type: type,
          id: l,
        }
      } else {
        ele = this.elements.pop()
        ele.value = msg
        ele.type = type
      }

      this.eleIndex = (this.eleIndex || 0) + 1
      ele.index = this.eleIndex
      this.elements.unshift(ele)
    },

    querySearch(str, cb) {
      const value = localStorage.getItem('callback:test')

      if (isJson(value)) {
        const items = JSON.parse(value) || []
        return cb(
          (str ? items.filter(it => it.includes(str)) : items).map(k => ({
            value: k,
          }))
        )
      }
      return cb([])
    },

    sendMessage(msg) {
      if (this.ws && msg) {
        this.ws.send(msg)
      }
    },
  },
}
</script>

<style scoped>
.callback-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
</style>

<style scoped lang="scss">
.basicPortContent {
  padding: 20px 20px 0 20px;
}

.callback-test {
  padding: 0;

  .callback-form {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }

  .listen-topic {
    font-size: 12px;
    // padding: 10px;
  }

  .listen-stat {
    & > span {
      font-size: 12px;

      & + span {
        margin-left: 5px;

        &::before {
          content: ',';
        }
      }
    }
  }

  .callback-container {
    height: calc(100vh - 260px);
    position: relative;
    overflow: auto;

    .callback-wrapper {
      padding: 10px;

      .callback-item {
        padding: 10px;
        transition: 0.3s;

        &,
        ::v-deepcode {
          font-family: Menlo, Monaco, Consolas, Courier, monospace,
            'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
            'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
          font-size: 13px;
        }
      }

      .callback-item + .callback-item {
        margin-top: 30px;
      }
    }
  }
}
</style>
